import actionTypes from '../../constants/actions/importarContactosExcel/importarContactosExcel'

export function initialState () {
  return {
    showModalImportarContactosExcel: false,
    archivoExcel: [],
    listImportarContactosExcel: []
  }
}

export function abrirModalImportarContactosExcel (state, {listCopiaSeguridad}) {
  return {
    ...state,
    showModalImportarContactosExcel: true
  }
}

export function cerrarModalImportarContactosExcel (state, {listCopiaSeguridad}) {
  return {
    ...state,
    showModalImportarContactosExcel: false,
    archivoExcel: [],
    listImportarContactosExcel: []
  }
}

export function subirArchivosImportarContactosExcel (state, {archivoExcel}) {
  return {
    ...state,
    archivoExcel: archivoExcel
  }
}

export function submitImportarContactosExcelSuccess (state, {listImportarContactosExcel}) {
  return {
    ...state,
    listImportarContactosExcel: listImportarContactosExcel
  }
}

export default function (state = initialState(), action) {
  switch (action.type) {
    case actionTypes.ABRIR_MODAL_IMPORTAR_CONTACTOS_EXCEL:
      return abrirModalImportarContactosExcel(state, action)
     case actionTypes.CERRAR_MODAL_IMPORTAR_CONTACTOS_EXCEL:
      return cerrarModalImportarContactosExcel(state, action)
     case actionTypes.SUBIR_ARCHIVOS_IMPORTAR_CONTACTOS_EXCEL:
      return subirArchivosImportarContactosExcel(state, action)
     case actionTypes.SUBMIT_IMPORTAR_CONTACTOS_EXCEL_SUCCESS:
      return submitImportarContactosExcelSuccess(state, action)
    default:
      return state
  }
}
